import { Component, OnInit ,Input} from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { stateOptionsSample } from 'src/app/constants/service.constants';
import { AdministrationSummaryService } from '../../services/administration/administration-summary.service';
import { Subject } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-document-type',
  templateUrl: './document-type-add.component.html',
  styleUrls: ['./document-type-add.component.scss']
})
export class DocumentTypeAddComponent implements OnInit {
  @Input() public Content: any;
  stateOptions :any[];
  content:any;
  AvailableDocs: any;
  columnDefs:any[];
  tempoperations: any[];
  heading:string;
  DocHeading:string;
  documentTypeForm: UntypedFormGroup;
  action: Subject<any> = new Subject();

  constructor(public modalRef: NgbActiveModal, 
    private summaryService: AdministrationSummaryService,
    public commonService: CommonService
    ) { }

  ngOnInit() {
    this.documentTypeForm = new UntypedFormGroup({
      DocumentName: new UntypedFormControl("", [Validators.required, Validators.maxLength(100)]),
      ISMANDATORY: new UntypedFormControl(false),
      ISSUPPORTMULTIPLEDOCUMENTS: new UntypedFormControl(false),
      IS_ACTIVE: new UntypedFormControl(true)
    });
    this.getDocumentTypes();
   
    if (this.Content.content.TargetScreen == "EAPType" && this.Content.heading == "Add"){
      this.DocHeading = "Add document"
      this.documentTypeForm.controls["ISSUPPORTMULTIPLEDOCUMENTS"].setValue(true);
    }
    else if (this.Content.content.TargetScreen == "EAPType" && this.Content.heading == "Edit"){
      this.documentTypeForm.controls["DocumentName"].setValue(this.Content.content.DocName);
      this.DocHeading = "Edit Document " + this.Content.content.DocName;
      this.documentTypeForm.controls["IS_ACTIVE"].setValue(this.Content.content.Status);
      this.documentTypeForm.controls["ISMANDATORY"].setValue(this.Content.content.ISMANDATORY);
      this.documentTypeForm.controls["ISSUPPORTMULTIPLEDOCUMENTS"].setValue(this.Content.content.ISMULTIDOC);
      this.DocHeading = "Edit Documents";
    }
    if (this.Content.content.TargetScreen != "EAPType" && this.Content.heading == "Edit") {
      this.DocHeading = "Edit Documents";
    }
  }
  getDocumentTypes() {
    this.summaryService.GetMasterDocumentType('api/DocumentType/GetMasterDocumentType').subscribe(summary => {
      this.stateOptions = summary;
    });
  }

  SaveDocumentType() {
    let hasValue;
    var formData = this.documentTypeForm.value;
    formData["ParentID"] = this.Content.content.id;
    formData["ParentName"] = this.Content.content.TargetScreen;
    formData["DocID"] = this.Content.content.DocID;
    let value = this.documentTypeForm.controls['DocumentName'].value;
   
    if(this.Content.content.DocList != undefined && this.Content.content.DocList != null){
      hasValue = this.Content.content.DocList.filter(x=> x.DocumentName.toLowerCase() == value.toLowerCase() && x.ID != this.Content.content.DocID);
    }

    if(hasValue !=undefined){
      if(hasValue.length > 0){
        this.commonService.ValidationBanner('Document ' + this.documentTypeForm.controls['DocumentName'].value + ' already exists. Please provide new Document Name to save the details');
      } else{
       // this.action.next(formData);
        this.modalRef.close(formData);
      }
    } else{
     // this.action.next(formData);
      this.modalRef.close(formData);
    }
    //formDate["DocumentName"] = this.stateOptions.find(x=>x.value == this.documentTypeForm.controls["DOCUMENTTYPE"].value).label;
  }

  Close(){
    this.canExit().then(x=>{
      this.modalRef.dismiss();
    });
  }

  canExit() {
    if (this.documentTypeForm.dirty && this.Content.heading != "Add") {
      return this.commonService.CanDeactivateBanner();
    }
    else {
      return Promise.resolve(true);
    }
  }

}
